<template>
  <div class="ferryDetail">
    <div class="loadingScreen" v-if="loading"></div>

    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="ferryDetail__container" v-if="ferry && !loading">
      <header class="ferryDetail__header">
        <router-link to="/" class="ferryDetail__backButton">Terug</router-link>
        <div class="ferryDetail__headerContent">
          <h1 class="ferryDetail__title">{{ ferry.title }}</h1>

          <div class="ferryDetail__service" v-if="!ferry.out_of_service_active">
            <div class="ferryDetail__isRunning">
              <span class="ferryDetail__isRunningDot" v-bind:class="{ '--red': !isRunning }"></span>
              <span class="ferryDetail__isRunningText">
                <span class="" v-if="isRunning && !statusChangeDatetime">Vaart.</span>
                <span class="" v-if="!isRunning && !statusChangeDatetime">Vaart niet.</span>
                <span class="" v-if="statusChangeDatetime && isRunning">Vaart tot {{ statusChangeDatetime }}.</span>
                <span class="" v-if="statusChangeDatetime && !isRunning">Vaart vanaf {{ statusChangeDatetime }}.</span>

                <!-- <span class="disclaimer">Bekijk altijd het vaarschema voor de actuele tijden</span> -->
              </span>
            </div>
          </div>

          <div class="ferryDetail__service" v-if="ferry.out_of_service_active">
            <div class="ferryDetail__isRunning">
              <span class="ferryDetail__isRunningDot --red"></span>
              <span class="ferryDetail__isRunningText">Vaart niet</span>
            </div>

            <div class="ferryDetail__outOfServiceDates">
              <div class="ferryDetail__outOfServiceDates__single">
                <span class="ferryDetail__outOfServiceDate">Vanaf:</span><span
                  v-if="ferry.out_of_service_active_start">{{
                    ferry.out_of_service_active_start
                  }}</span>
              </div>

              <div class="ferryDetail__outOfServiceDates__single" v-if="ferry.out_of_service_active_end">
                <span class="ferryDetail__outOfServiceDate">Tot:</span><span>{{
                  ferry.out_of_service_active_end
                }}</span>
              </div>
            </div>

            <span v-if="ferry.out_of_service_active_reason"
              class="ferryDetail__outOfServiceReason"><strong>Reden</strong>: {{ ferry.out_of_service_active_reason }}
            </span>
          </div>

          <div class="ferryDetail__service" v-if="ferry.out_of_service">
            <div class="ferryDetail__isRunning">
              <span class="ferryDetail__isRunningDot --red"></span>
              <span class="ferryDetail__isRunningText">Geplande stremming</span>
            </div>

            <div class="ferryDetail__outOfServiceDates">
              <div class="ferryDetail__outOfServiceDates__single">
                <span class="ferryDetail__outOfServiceDate">Vanaf:</span><span v-if="ferry.out_of_service_start">{{
                  ferry.out_of_service_start
                }}</span>
              </div>

              <div class="ferryDetail__outOfServiceDates__single" v-if="ferry.out_of_service_end">
                <span class="ferryDetail__outOfServiceDate">Tot:</span><span>{{
                  ferry.out_of_service_end
                }}</span>
              </div>
            </div>

            <span v-if="ferry.out_of_service_reason" class="ferryDetail__outOfServiceReason"><strong>Reden</strong>: {{
              ferry.out_of_service_reason }}
            </span>
          </div>

          <div class="ferryDetail__service" v-if="ferry.announcement">
            <div class="ferryDetail__isRunning">
              <span class="ferryDetail__isRunningDot --orange"></span>
              <span class="ferryDetail__isRunningText">Mededeling</span>
            </div>

            <span class="ferryDetail__announcement">{{ ferry.announcement }}
            </span>
          </div>

          <div class="ferryDetail__headerContent__sub">
            <ul class="summaryList -small -light">
              <li class="summaryList__item" v-if="ferry.type">
                {{ ferry.type.title }}
              </li>
              <li class="summaryList__item" v-for="water in ferry.waters">
                {{ water.title }}
              </li>
            </ul>

            <ul class="methods" v-if="ferry.transports">
              <li class="methods__item text">Toegankelijk voor</li>
              <li class="methods__item" v-for="transport in ferry.transports" :class="transport.slug">
                {{ transport.title }}
              </li>
              <!-- .methods__item -->
            </ul>
            <!-- .methods -->

            <ul class="methods">
              <li class="methods__item text" v-if="ferry.pin_available == 'yes'">
                PIN is beschikbaar
              </li>
              <li class="methods__item text" v-if="ferry.pin_available == 'no'">
                PIN is niet beschikbaar
              </li>
              <li class="methods__item pin" v-if="ferry.pin_available !== 'nvt'">
                PIN
              </li>
            </ul>
            <!-- .methods -->

            <div class="dialog hidden" ref="activationDialog">
              <div class="dialog__inner">
                <button class="dialog__inner__close" v-on:click="closeActivationDialog">
                  Sluiten
                </button>

                <h2 class="dialog__inner__title">
                  {{ ferry.texts.activated.heading }}
                </h2>

                <p class="dialog__inner__text">
                  {{ ferry.texts.activated.text }}
                  <strong>{{ ferry.title }}</strong>.
                </p>

                <div class="dialog__inner__box">
                  <h3 class="dialog__inner__box__title">
                    {{ ferry.texts.activated.subheading }}
                  </h3>

                  <p class="dialog__inner__box__subtext">
                    {{ ferry.texts.activated.subtext }}
                  </p>
                </div>
              </div>
            </div>

            <div class="dialog hidden" ref="deactivationDialog">
              <div class="dialog__inner">
                <button class="dialog__inner__close" v-on:click="closeDeactivationDialog">
                  Sluiten
                </button>

                <h2 class="dialog__inner__title">
                  {{ ferry.texts.deactivated.heading }}
                </h2>

                <p class="dialog__inner__text">
                  {{ ferry.texts.deactivated.text }}
                  <strong>{{ ferry.title }}</strong>.
                </p>
              </div>
            </div>

            <div>
              <button class="ferryDetail__dialogButton" v-on:click="toggleSignupDialog">
                {{ ferry.texts.signup.button }}
              </button>
            </div>

            <div class="dialog hidden" ref="dialog">
              <div class="dialog__inner">
                <button class="dialog__inner__close" v-on:click="toggleSignupDialog">
                  Sluiten
                </button>

                <div v-if="formSubmit">
                  <h2 class="dialog__inner__title">
                    {{ ferry.texts.check.heading }}
                  </h2>

                  <p class="dialog__inner__text">
                    {{ ferry.texts.check.text }}
                  </p>

                  <div class="dialog__inner__box">
                    <h3 class="dialog__inner__box__title">
                      {{ ferry.texts.check.boxheading }}
                    </h3>

                    <p class="dialog__inner__box__text">
                      {{ ferry.texts.check.boxtext }}
                    </p>

                    <h4 class="dialog__inner__box__subtitle">
                      {{ ferry.texts.check.boxsubheading }}
                    </h4>

                    <p class="dialog__inner__box__subtext">
                      {{ ferry.texts.check.boxsubtext }}
                      <a href="mailto:info@veerponten.nl">info@veerponten.nl</a>.
                    </p>
                  </div>
                </div>

                <div v-if="!formSubmit">
                  <h2 class="dialog__inner__title">
                    {{ ferry.texts.signup.heading }}
                  </h2>

                  <p class="dialog__inner__text">
                    {{ ferry.texts.signup.text }}
                  </p>

                  <form class="dialog__form" v-on:submit.prevent="onSubmitSubscribe">
                    <input class="dialog__form__input" type="email" id="subscribeEmail" v-model="subscribeEmail"
                      placeholder="Uw e-mailadres..." />

                    <input class="dialog__form__checkbox" type="checkbox" id="privacy" v-model="subscribePrivacy" />
                    <label for="privacy">Ik ga akkoord met het ontvangen van e-mails. Mijn
                      gegevens worden verwerkt volgens de
                      <a href="/vereniging/privacyverklaring">privacyverklaring</a>.</label>

                    <button class="dialog__form__submit" ref="formSubmit" type="submit">
                      Aanmelden
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- .ferryDetail__headerContent -->
      </header>
      <!-- .ferryDetail__header -->

      <carousel :perPage="1" :navigationEnabled="true" :paginationEnabled="false" :loop="true" navigationNextLabel=""
        navigationPrevLabel="" v-if="ferry.gallery">
        <slide v-for="image in ferry.gallery" v-bind:key="image.id">
          <img class="tinyGallery__item" :src="image.sizes.large" :alt="image.alt" :title="image.title" />
        </slide>
      </carousel>

      <!-- <div class="tinyGallery" v-if="ferry.gallery">
        <img class="tinyGallery__item" v-for="image in ferry.gallery" :src="image.sizes.large" :alt="image.alt" :title="image.title">
      </div> -->

      <div class="collapse">
        <div class="collapse__item" :class="{ '-is-open': collapseSelected('schedule') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('schedule')">
            Vaarschema
          </h3>
          <div class="collapse__itemContent">
            <div class="timeSchedule" v-if="ferry.scheme && ferry.scheme.length > 0">
              <div class="timeSchedule__range" v-for="period in ferry.scheme">
                <h4 class="timeSchedule__rangeTitle">
                  {{ readableDate(period.fromDate) }} t/m
                  {{ readableDate(period.tillDate) }}
                </h4>

                <div v-if="period.monday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">ma:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.monday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.monday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.monday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.monday.note != ''">
                      {{ period.monday.note }}
                    </div>
                  </div>
                </div>

                <div v-if="period.tuesday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">di:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.tuesday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.tuesday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.tuesday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.tuesday.note != ''">
                      {{ period.tuesday.note }}
                    </div>
                  </div>
                </div>

                <div v-if="period.wednesday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">wo:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.wednesday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.wednesday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.wednesday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.wednesday.note != ''">
                      {{ period.wednesday.note }}
                    </div>
                  </div>
                </div>

                <div v-if="period.thursday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">do:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.thursday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.thursday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.thursday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.thursday.note != ''">
                      {{ period.thursday.note }}
                    </div>
                  </div>
                </div>

                <div v-if="period.friday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">vr:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.friday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.friday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.friday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.friday.note != ''">
                      {{ period.friday.note }}
                    </div>
                  </div>
                </div>

                <div v-if="period.saturday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">za:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.saturday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.saturday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.saturday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.saturday.note != ''">
                      {{ period.saturday.note }}
                    </div>
                  </div>
                </div>

                <div v-if="period.sunday" class="timeSchedule__item clearfix">
                  <div class="timeSchedule__itemTitle">zo:</div>
                  <div class="timeSchedule__itemContent">
                    <span v-if="period.sunday.allDay">hele dag</span>
                    <div class="timeSchedule__timeRanges" v-if="!period.sunday.allDay">
                      <div class="timeSchedule__timeRange" v-for="timeRange in period.sunday.times">
                        {{ timeRange.fromTime }} - {{ timeRange.tillTime }}
                      </div>
                    </div>
                    <div class="timeSchedule__note" v-if="period.sunday.note != ''">
                      {{ period.sunday.note }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- .timeSchedule -->

            <!-- <pre style="font-family: inherit; font-size: inherit;">{{ ferry.scheme_txt }}</pre> -->

            <div v-if="donationLink" class="wysiwyg">
              <p>
                <a :href="donationLink.url">
                  {{ donationLink.label }}
                </a>
              </p>
            </div>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->
        <div class="collapse__item" v-if="ferry.holidays" :class="{ '-is-open': collapseSelected('holidays') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('holidays')">
            Feestdagen
          </h3>
          <div class="collapse__itemContent">
            <div class="wysiwyg">
              <div v-for="holiday in ferry.holidays" class="timeSchedule__item -bigLabel clearfix">
                <div class="timeSchedule__itemTitle">{{ holiday.label }}</div>
                <div class="timeSchedule__itemContent">
                  <span>{{ holiday.desc }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->
        <div class="collapse__item" v-if="ferry.stops" :class="{ '-is-open': collapseSelected('stops') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('stops')">
            Haltes
          </h3>
          <div class="collapse__itemContent">
            <div class="wysiwyg">
              <ul class="-noMarginTop">
                <li v-for="stop in ferry.stops">
                  <a :href="googleMapsUrl(stop.lat, stop.lng)" target="_blank">{{ stop.title }}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->

        <div class="collapse__item" :class="{ '-is-open': collapseSelected('details') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('details')">
            Gegevens
          </h3>
          <div class="collapse__itemContent">
            <p v-if="ferry.nickname">
              <strong>Naam boot:</strong><br />{{ ferry.nickname }}
            </p>
            <p v-if="ferry.type">
              <strong>Type boot:</strong><br />
              {{ ferry.type.title }}
            </p>
            <p v-if="ferry.numbers" class="-noMarginBottom">
              <strong>Nummers:</strong>
            </p>
            <ul v-if="ferry.numbers" class="summaryList -slashes">
              <li v-for="number in ferry.numbers" class="summaryList__item">
                {{ number.title }}
              </li>
            </ul>
            <p v-if="ferry.waters" class="-noMarginBottom">
              <strong>Vaart over:</strong>
            </p>
            <ul v-if="ferry.waters" class="summaryList">
              <li v-for="water in ferry.waters" class="summaryList__item">
                {{ water.title }}
              </li>
            </ul>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->

        <div v-if="ferry.notes" class="collapse__item" :class="{ '-is-open': collapseSelected('comments') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('comments')">
            Opmerkingen
          </h3>
          <div class="collapse__itemContent">
            <div v-html="ferry.notes"></div>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->

        <div class="collapse__item" v-if="ferry.videos" :class="{ '-is-open': collapseSelected('videos') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('videos')">
            Video's
          </h3>
          <div class="collapse__itemContent">
            <div class="wysiwyg">
              <ul class="-noMarginTop">
                <li v-for="video in ferry.videos">
                  <a :href="video.url" target="_blank">{{ video.title }}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->
        <div class="collapse__item" :class="{ '-is-open': collapseSelected('contact') }">
          <h3 class="collapse__itemTitle" v-on:click="collapseSelect('contact')">
            Contact
          </h3>
          <div class="collapse__itemContent">
            <div class="wysiwyg" v-if="ferry.captains">
              <p v-for="captain in ferry.captains">
                <strong v-if="captain.name">{{ captain.name }}<br /></strong>
                <span v-if="captain.email"><a :href="mailTo(captain.email)">{{ captain.email }}</a><br /></span>
                <span v-if="captain.phonenumber"><a :href="callTo(captain.phonenumber)">{{
                  captain.phonenumber
                    }}</a></span>
              </p>
            </div>

            <div class="wysiwyg" v-if="ferry.emails">
              <p class="-noMarginBottom"><strong>E-mail:</strong></p>
              <ul class="-noMarginTop">
                <li v-for="email in ferry.emails">
                  <a :href="mailTo(email.email)">{{ email.email }}</a>
                </li>
              </ul>
            </div>

            <div class="wysiwyg" v-if="ferry.phone_numbers">
              <p class="-noMarginBottom"><strong>Telefoon:</strong></p>
              <ul class="-noMarginTop">
                <li v-for="phonenumber in ferry.phone_numbers">
                  {{ phonenumber.title }}:
                  <a :href="callTo(phonenumber.phonenumber)">{{
                    phonenumber.phonenumber
                  }}</a>
                </li>
              </ul>
            </div>

            <div class="wysiwyg" v-if="ferry.links">
              <p class="-noMarginBottom"><strong>Links:</strong></p>
              <ul class="-noMarginTop">
                <li v-for="link in ferry.links">
                  <a :href="link.url" target="_blank">{{ link.title }}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- .collapse__itemContent -->
        </div>
        <!-- .collapse__item -->
      </div>
      <!-- .collapse -->

      <div v-if="donationCTA" class="donation__cta">
        <h3 class="donation__ctaTitle font-heading-xl">
          {{ donationCTA.title }}
        </h3>

        <p class="donation__ctaContent font-body-s">
          {{ donationCTA.content }}
        </p>

        <a class="donation__ctaButton font-button-m button-secondary button-secondary__full-width"
          :href="donationCTA.button.url">
          {{ donationCTA.button.label }}
        </a>
      </div>

      <div class="ferryDetail__footer">
        <div class="wysiwyg">
          <p v-if="ferry.website">
            <a :href="ferry.website" target="_blank">website openen</a>
          </p>
          <p><a :href="reportLink(ferry.title)">wijzigingen doorgeven</a></p>
        </div>
        <!-- wysiwyg -->
      </div>
      <!-- .ferryDetail__footer -->
    </div>
    <!-- .ferryDetail__content -->
  </div>
  <!-- .ferryDetail -->
</template>

<script>
export default {
  name: "Detail",
  props: ["loadingOverview"],

  data() {
    return {
      subscribeEmail: "",
      subscribePrivacy: false,
      selectedCollapseItem: "",
      loading: false,
      formSubmit: false,
      notificationsActivated: false,
      notificationsDeactivated: false,
      ferry: null,
      error: null,
      isRunning: null,
      statusChangeDate: null,
      timeStamp: null,
    };
  },

  computed: {
    donationLink() {
      return this.ferry?.donation?.link || null;
    },

    donationCTA() {
      return this.ferry?.donation?.cta || null;
    },

    statusChangeDatetime: function () {
      if (this.statusChangeDate) {
        const parseDateTime = this.statusChangeDate.split("+");
        const parsedDate = parseDateTime[0].split("-");
        const parsedTime = parseDateTime[1].split(":");

        const year = parsedDate[0];
        const month = parsedDate[1];
        const day = parsedDate[2];

        const hour = parsedTime[0];
        const minute = parsedTime[1];

        const today = new Date();
        const tomorrow = new Date(Date.now() + 3600 * 1000 * 24);

        const date = new Date(year, month - 1, day, hour, minute);

        var days = [
          "zondag",
          "maandag",
          "dinsdag",
          "woensdag",
          "donderdag",
          "vrijdag",
          "zaterdag",
        ];
        var months = [
          "january",
          "february",
          "maart",
          "april",
          "mei",
          "juni",
          "juli",
          "augustus",
          "september",
          "oktober",
          "november",
          "december",
        ];

        if (this.sameDay(today, date)) {
          return hour + ":" + minute + " u";
        } else if (this.sameDay(tomorrow, date)) {
          return "morgen " + hour + ":" + minute + " u";
        } else {
          return (
            days[date.getDay()] +
            " " +
            date.getDate() +
            " " +
            months[date.getMonth()] +
            " om " +
            hour +
            ":" +
            minute +
            " u"
          );
        }
      }
      return this.statusChangeDate; // null
    },
  },

  created() {
    this.fetchData();

    const query = this.$route.query;

    if (query.token && query.signup_id && query.post_id && query.activate) {
      this.activateNotifications();
    }

    if (query.token && query.signup_id && query.post_id && query.deactivate) {
      this.deactivateNotifications();
    }
  },

  updated() {
    if (this.notificationsActivated) {
      this.showActivationDialog();
    }

    if (this.notificationsDeactivated) {
      this.showDeactivationDialog();
    }
  },

  destroyed() {
    this.$emit("select-ferry", null);
  },

  watch: {
    $route: "fetchData",
  },

  methods: {
    showDeactivationDialog() {
      const content = document.getElementById("page");

      if (content && this.$refs.deactivationDialog) {
        content.appendChild(this.$refs.deactivationDialog);

        this.$refs.deactivationDialog.classList.remove("hidden");
      }
    },

    showActivationDialog() {
      const content = document.getElementById("page");

      if (content && this.$refs.activationDialog) {
        content.appendChild(this.$refs.activationDialog);

        this.$refs.activationDialog.classList.remove("hidden");
      }
    },

    closeDeactivationDialog() {
      if (this.$refs.deactivationDialog) {
        this.$refs.deactivationDialog.classList.add("hidden");
      }
    },

    closeActivationDialog() {
      if (this.$refs.activationDialog) {
        this.$refs.activationDialog.classList.add("hidden");
      }
    },

    toggleSignupDialog() {
      const content = document.getElementById("page");

      if (content && this.$refs.dialog) {
        content.appendChild(this.$refs.dialog);

        this.$refs.dialog.classList.toggle("hidden");
      }
    },

    deactivateNotifications() {
      fetch(
        `${process.env.WEBSITE_URL}/wp-json/sdc/v1/notifications/${this.$route.query.signup_id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: this.$route.query.token,
            postId: this.$route.query.post_id,
          }),
        },
      ).then(() => {
        this.notificationsDeactivated = true;
      });
    },

    activateNotifications() {
      fetch(
        `${process.env.WEBSITE_URL}/wp-json/sdc/v1/notifications/${this.$route.query.signup_id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: this.$route.query.token,
            postId: this.$route.query.post_id,
          }),
        },
      ).then(() => {
        this.notificationsActivated = true;
      });
    },

    onSubmitSubscribe() {
      this.$refs.formSubmit.innerHTML = "Verzenden...";

      fetch(`${process.env.WEBSITE_URL}/wp-json/sdc/v1/notifications`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: this.subscribeEmail,
          privacy: this.subscribePrivacy,
          postId: this.ferry.ID,
        }),
      }).then(() => {
        this.formSubmit = true;
      });
    },

    reportLink(ferryName) {
      return (
        process.env.WEBSITE_URL +
        "/wijziging-doorgeven/?ferry=" +
        encodeURIComponent(ferryName)
      );
    },

    readableDate(date) {
      const splitDate = date.split("/");
      const currentMonth = Number(splitDate[1]);
      const currentDay = Number(splitDate[0]);
      const months = [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december",
      ];
      return currentDay + " " + months[currentMonth - 1];
    },

    sameDay(d1, d2) {
      return (
        d1.getUTCFullYear() === d2.getUTCFullYear() &&
        d1.getUTCMonth() === d2.getUTCMonth() &&
        d1.getUTCDate() === d2.getUTCDate()
      );
    },

    outOfServiceActive(slots) {
      const today = new Date().getTime();
      var slot, start_date, start, end_date, end;

      if (slots) {
        this.ferry.out_of_service_active = true;

        for (var i = 0; i < slots.length; i++) {
          slot = slots[i];
          start_date = slot.date_start.split(" ")[0].split("/");
          start = new Date(start_date[2], start_date[1] - 1, start_date[0]);

          if (slot.date_end) {
            end_date = slot.date_end.split(" ")[0].split("/");
            end = new Date(end_date[2], end_date[1] - 1, end_date[0]);
          }

          this.ferry.out_of_service_active_start =
            start.getDate() +
            "/" +
            (start.getMonth() + 1) +
            "/" +
            start.getFullYear();

          if (slot.date_end) {
            this.ferry.out_of_service_active_end =
              end.getDate() +
              "/" +
              (end.getMonth() + 1) +
              "/" +
              end.getFullYear();
          } else if (today > start.getTime()) {
            this.ferry.out_of_service_active_end = false;
          }

          if (slot.reason) {
            this.ferry.out_of_service_active_reason = slot.reason;
          } else {
            this.ferry.out_of_service_active_reason = false;
          }

          return true;
        }
      }

      this.ferry.out_of_service_active = false;
      return false;
    },

    outOfService(slots) {
      const today = new Date().getTime();
      var slot, start_date, start, end_date, end;

      if (slots) {
        this.ferry.out_of_service = true;

        for (var i = 0; i < slots.length; i++) {
          slot = slots[i];
          start_date = slot.date_start.split(" ")[0].split("/");
          start = new Date(start_date[2], start_date[1] - 1, start_date[0]);

          if (slot.date_end) {
            end_date = slot.date_end.split(" ")[0].split("/");
            end = new Date(end_date[2], end_date[1] - 1, end_date[0]);
          }

          if (start.getTime() < today &&
            (!end || (end && end.getTime() > today))) {
            if (!this.ferry.out_of_service_active) {
              this.ferry.out_of_service = false;
              this.outOfServiceActive(slots);

              return;
            }
          }

          if (slot.date_end) {
            this.ferry.out_of_service_start =
              start.getDate() +
              "/" +
              (start.getMonth() + 1) +
              "/" +
              start.getFullYear();
            this.ferry.out_of_service_end =
              end.getDate() +
              "/" +
              (end.getMonth() + 1) +
              "/" +
              end.getFullYear();

            if (slot.reason) {
              this.ferry.out_of_service_reason = slot.reason;
            } else {
              this.ferry.out_of_service_reason = false;
            }
            return true;
          } else if (today > start.getTime()) {
            this.ferry.out_of_service_end = false;

            if (slot.reason) {
              this.ferry.out_of_service_reason = slot.reason;
            } else {
              this.ferry.out_of_service_reason = false;
            }

            return true;
          }
        }
      }

      this.ferry.out_of_service = false;
      return false;
    },

    mailTo(email) {
      return "mailto:" + email;
    },

    callTo(phonenumber) {
      return "tel:" + phonenumber;
    },

    commaSeparated(values) {
      return values.join(", ");
    },

    slashSeparated(values) {
      return values.join(" / ");
    },

    collapseSelect(item) {
      this.selectedCollapseItem = item;
    },

    collapseSelected(item) {
      return item === this.selectedCollapseItem;
    },

    googleMapsUrl(lat, lng) {
      return `https://www.google.com/maps/place/${lat}+${lng}/@${lat},${lng},12z`;
    },

    async fetchIsRunning(ID) {
      this.loading = true;

      try {
        const response = await fetch(process.env.API + "/is_running/" + ID, {
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        const result = await response.json();

        this.timeStamp = this.getTimeStamp();
        this.isRunning = result.is_running;
        this.statusChangeDate = result.status_change_date;
        this.loading = false;
      } catch (error) {
        console.log("error, no data", error);
      } finally {
        this.loading = false;
      }
    },

    getTimeStamp() {
      const now = new Date();
      const hours = now.getHours().toString();
      const minutes = now.getMinutes().toString();
      const hoursFormatted = hours.length === 1 ? `0${hours}` : hours;
      const minutesFormatted = minutes.length === 1 ? `0${minutes}` : minutes;

      return `${hoursFormatted}:${minutesFormatted}`;
    },

    async fetchData() {
      const slug = this.$route.params.slug;

      this.error = this.ferry = null;
      this.loading = true;

      try {
        const response = await fetch(process.env.API + "/ferry/slug/" + slug, {
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        const ferry = await response.json();

        this.$emit("select-ferry", ferry.slug);
        this.fetchIsRunning(ferry.ID);
        this.ferry = ferry;
        this.outOfServiceActive(ferry.out_of_service_active_slots);
        this.outOfService(ferry.out_of_service_slots);
      } catch (error) {
        console.log("error, no data", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 1em;

  opacity: 1;
  background-color: rgba(25, 39, 58, 0.9);

  transition:
    left 0ms 0ms,
    opacity 150ms;
}

.dialog.hidden {
  left: 100vw;
  opacity: 0;

  transition:
    left 0ms 150ms,
    opacity 150ms;
}

.dialog__inner {
  position: relative;

  width: 100%;
  max-width: 500px;
  padding: 1.25em;

  background-color: white;
}

.dialog__inner__close {
  position: absolute;
  top: 1em;
  right: 1em;

  background-color: transparent;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjMxNDMgNS4xMDQ5OEw1LjEwNDc0IDE1LjMxNDUiIHN0cm9rZT0iIzE5MjczQSIgc3Ryb2tlLXdpZHRoPSIxLjcwMTU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuMTA0NzQgNS4xMDQ5OEwxNS4zMTQzIDE1LjMxNDUiIHN0cm9rZT0iIzE5MjczQSIgc3Ryb2tlLXdpZHRoPSIxLjcwMTU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
  background-size: cover;
  background-position: center;

  border: 0;
  padding: 0;
  width: 1.5em;
  height: 1.5em;

  text-indent: 99999em;
  cursor: pointer;
}

.dialog__inner__title {
  margin-top: 0;
  margin-bottom: 6px;

  font-family: "Roboto Condensed";
  font-size: 2em;
  font-weight: normal;
}

.dialog__inner__text {
  margin-top: 0;
  margin-bottom: 16px;

  font-size: 1.125em;
}

.dialog__inner__box {
  padding: 12px;
  margin-top: 1em;

  background-color: #f2f2f2;
}

.dialog__inner__box__title {
  font-family: "Roboto Condensed";
  font-size: 1.5em;
  font-weight: normal;

  margin-top: 0;
  margin-bottom: 6px;
}

.dialog__inner__box__text {
  font-size: 1em;

  margin-top: 0;
  margin-bottom: 24px;
}

.dialog__inner__box__subtitle {
  font-weight: 700;
  font-size: 1em;

  margin-top: 0;
  margin-bottom: 0;
}

.dialog__inner__box__subtext {
  font-size: 1em;

  margin-top: 0;
  margin-bottom: 0;
}

.dialog__form {
  display: flex;
  flex-direction: column;
}

.dialog__form__input {
  width: 100%;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid #9ea8bc;
  border-radius: 8px;
}

.dialog__form__checkbox {
  display: none;
}

.dialog__form__checkbox+label {
  position: relative;

  padding-left: 28px;
  margin-bottom: 20px;
}

.dialog__form__checkbox+label::before {
  content: "";

  position: absolute;
  left: 0;
  top: 0;

  display: block;

  border: 1px solid #9ea8bc;
  width: 18px;
  height: 18px;
}

.dialog__form__checkbox:checked+label::after {
  content: "";

  position: absolute;
  left: 4px;
  top: 4px;

  display: block;

  width: 10px;
  height: 10px;

  background-color: #007fb8;
}

.dialog__form__submit {
  appearance: none;
  cursor: pointer;

  padding: 12px 20px;
  border: 0;
  border-radius: 8px;

  font-weight: 500;
  text-transform: uppercase;

  color: white;
  background-color: #007fb8;
}

.ferryDetail__dialogButton {
  border: 0;
  padding: 0;
  appearance: none;
  background-color: transparent;
  color: #007fb8;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
}

.ferryDetail {
  height: 100%;
  overflow: auto;
  width: 100%;
}

.ferryDetail__header {
  padding: 3em 0 0;
  position: relative;
}

.ferryDetail__footer {
  text-align: center;
  padding: 0 12px 1.8em;
}

.ferryDetail__backButton {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjI1IDguNUgzLjc1IiBzdHJva2U9IiMxOTI3M0EiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgMy4yNUwzLjc1IDguNUw5IDEzLjc1IiBzdHJva2U9IiMxOTI3M0EiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
  background-position: left center;
  background-size: 1em;
  background-repeat: no-repeat;
  color: #19273a;
  display: block;
  overflow: hidden;
  font-size: 1.25em;
  font-weight: 500;
  line-height: 1.6;
  padding-left: 1.25em;
  margin-left: 12px;
  text-decoration: none;
  transition: transform 0.6s ease-out;
}

.ferryDetail__backButton:hover {
  transform: translateX(-3px);
  transition: transform 0.4s ease-in-out;
}

.ferryDetail__title {
  color: #19273a;
  font-family: "Roboto Condensed";
  font-weight: 400;
  margin: 0 0 12px;
  padding: 0 12px;
}

.ferryDetail__outOfService {
  background-color: rgb(253, 199, 0);
  border-radius: 3px;
  padding: 6px;
  line-height: 1;
  display: inline-block;
  font-size: 0.9em;
  margin-bottom: 5px;
  margin-top: 5px;
}

.ferryDetail__outOfService.-hasReason {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: 0;
  width: 100%;
  padding: 9px 7px;
}

.ferryDetail__outOfServiceReason {
  background-color: #f2f2f2;
  border: 1px solid #d7d7d7;
  display: inline-block;
  margin-top: 12px;
  padding: 8px 6px;
  font-size: 0.9em;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  width: 100%;
}

.collapse {
  border-bottom: 1px solid rgba(25, 39, 58, 0.3);
  padding: 0;
}

.collapse__item {
  border-top: 1px solid rgba(25, 39, 58, 0.3);
  margin: 0;
  padding: 0;
}

.collapse__itemTitle {
  color: #19273a;
  cursor: pointer;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 1.2em;
  font-weight: 400;
  margin: 0;
  padding: 1.2em 1em 1.2em 12px;
}

.collapse__itemTitle:after {
  content: "\f107";
  font-family: "FontAwesome";
  float: right;
  transform: rotate(0deg);
  transition: transform 0.4s ease-in-out;
}

.collapse__itemContent {
  max-height: 0;
  overflow: hidden;
  padding: 0 12px;
  transition: max-height 0.6s ease-in-out;
  width: 100%;
}

.collapse__itemContent:after {
  content: "";
  display: block;
  height: 1.8em;
}

.collapse__item.-is-open .collapse__itemContent {
  max-height: 1500px;
}

.collapse__item.-is-open .collapse__itemTitle:after {
  transform: rotate(180deg);
}

.summaryList {
  list-style: none;
  margin: 0 0 1.5em;
  padding: 0;
}

.summaryList__item {
  display: inline;
}

.summaryList__item:after {
  content: ", ";
}

.summaryList__item:last-child:after {
  content: none !important;
}

.summaryList.-small {
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}

.summaryList.-light {
  color: #2a4567;
  opacity: 0.65;
}

.summaryList.-slashes .summaryList__item:after {
  content: " / ";
}

.tinyGallery {
  margin: 0 0 1.8em;
  width: 100%;
}

.tinyGallery__item {
  display: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tinyGallery__item:first-child {
  display: block;
}

.timeSchedule {
  color: #19273a;
  font-family: "Roboto", sans-serif;
}

.timeSchedule__range {
  padding-top: 1.5em;
}

.timeSchedule__range:first-child {
  padding-top: 0;
}

.timeSchedule__rangeTitle {
  color: #19273a;
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  margin: 0 0 6px;
}

.timeSchedule__item {
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.timeSchedule__item:after {
  clear: both;
  content: " ";
  display: block;
  font-size: 0;
  height: 0;
  visibility: hidden;
}

.timeSchedule__itemTitle {
  display: block;
  float: left;
  font-weight: bolder;
  width: 20%;
}

.timeSchedule__itemContent {
  display: block;
  float: right;
  width: 80%;
}

.ferryDetail__headerContent__sub {
  border-top: 1px solid rgba(25, 39, 58, 0.3);
  padding: 1.2em 12px 1.2em;

  font-size: 1.2em;
}

.ferryDetail__service {
  display: flex;
  flex-direction: column;

  border-top: 1px solid rgba(25, 39, 58, 0.3);
  padding: 1.2em 12px 1.2em;
}

.ferryDetail__outOfServiceDates {
  margin-top: 12px;
}

.ferryDetail__outOfServiceDates__single {
  display: flex;
  align-items: center;
}

.ferryDetail__outOfServiceDate {
  font-weight: 700;
  width: 50px;
}

.ferryDetail__announcement {
  display: block;
  margin-top: 12px;
  font-size: 1em;
  width: 100%;
}

.ferryDetail__isRunning {
  display: flex;
  align-items: center;

  color: #19273a;

  font-size: 1.2em;
  font-weight: 400;
  font-family: "Roboto Condensed", sans-serif;
}

.ferryDetail__isRunningText span.disclaimer {
  color: Red;
  display: block;
  margin-top: 5px;

  font-size: 12px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  color: #2a4567;
  opacity: 0.65;
}

.ferryDetail__isRunningDot {
  margin-right: 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: #8ca833;
}

.ferryDetail__isRunningDot.--red {
  background-color: #e9585b;
}

.ferryDetail__isRunningDot.--orange {
  background-color: #db7d27;
}

@media screen and (max-width: 300px) {

  .timeSchedule__itemTitle,
  .timeSchedule__itemContent {
    word-break: break-all;
  }
}

.timeSchedule__item.-bigLabel {
  margin-bottom: 10px;
}

.timeSchedule__item.-bigLabel .timeSchedule__itemTitle {
  width: 45%;
  padding-right: 5px;
}

.timeSchedule__item.-bigLabel .timeSchedule__itemContent {
  width: 55%;
}

.timeSchedule__item+.timeSchedule__range {
  padding-top: 1em;
}

.wysiwyg ul.-noMarginTop {
  margin-top: 0;
}

p.-noMarginBottom {
  margin-bottom: 0;
}

/* Override carousel */

.VueCarousel-navigation-button {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 15px;
  height: 20px;
  color: transparent;
  background-image: url("data:image/svg+xml;base64,DQo8c3ZnIHdpZHRoPSI3cHgiIGhlaWdodD0iMTFweCIgdmlld0JveD0iMCAwIDcgMTEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+DQogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4xICg1MTE0NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSJTdGlqbCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJ2ZWVycG9udC9kZXNrdG9wIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAuMDAwMDAwLCAtMTU1LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPg0KICAgICAgICAgICAgPHBhdGggZD0iTTE2LjI5Nzk5ODYsMTU2LjAzNTcwMiBDMTYuMjk3OTk4NiwxNTYuMTE2MDYgMTYuMjU3ODIsMTU2LjIwNjQ2MiAxNi4xOTc1NTIsMTU2LjI2NjcyOSBMMTIuMjUwMDAyNywxNjAuMjE0Mjc5IEwxNi4xOTc1NTIsMTY0LjE2MTgyOCBDMTYuMjU3ODIsMTY0LjIyMjA5NiAxNi4yOTc5OTg2LDE2NC4zMTI0OTggMTYuMjk3OTk4NiwxNjQuMzkyODU1IEMxNi4yOTc5OTg2LDE2NC40NzMyMTIgMTYuMjU3ODIsMTY0LjU2MzYxNCAxNi4xOTc1NTIsMTY0LjYyMzg4MiBMMTUuNjk1MzE5MywxNjUuMTI2MTE1IEMxNS42MzUwNTE0LDE2NS4xODYzODMgMTUuNTQ0NjQ5NSwxNjUuMjI2NTYyIDE1LjQ2NDI5MjIsMTY1LjIyNjU2MiBDMTUuMzgzOTM1LDE2NS4yMjY1NjIgMTUuMjkzNTMzMSwxNjUuMTg2MzgzIDE1LjIzMzI2NTIsMTY1LjEyNjExNSBMMTAuNTUyNDU2LDE2MC40NDUzMDYgQzEwLjQ5MjE4ODEsMTYwLjM4NTAzOCAxMC40NTIwMDk1LDE2MC4yOTQ2MzYgMTAuNDUyMDA5NSwxNjAuMjE0Mjc5IEMxMC40NTIwMDk1LDE2MC4xMzM5MjIgMTAuNDkyMTg4MSwxNjAuMDQzNTIgMTAuNTUyNDU2LDE1OS45ODMyNTIgTDE1LjIzMzI2NTIsMTU1LjMwMjQ0MyBDMTUuMjkzNTMzMSwxNTUuMjQyMTc1IDE1LjM4MzkzNSwxNTUuMjAxOTk2IDE1LjQ2NDI5MjIsMTU1LjIwMTk5NiBDMTUuNTQ0NjQ5NSwxNTUuMjAxOTk2IDE1LjYzNTA1MTQsMTU1LjI0MjE3NSAxNS42OTUzMTkzLDE1NS4zMDI0NDMgTDE2LjE5NzU1MiwxNTUuODA0Njc1IEMxNi4yNTc4MiwxNTUuODY0OTQzIDE2LjI5Nzk5ODYsMTU1Ljk0NTMwMSAxNi4yOTc5OTg2LDE1Ni4wMzU3MDIgWiIgaWQ9Iu+EhCI+PC9wYXRoPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+");
  outline: none !important;
  transition: transform 0.3s;
}

.VueCarousel-navigation-prev {
  transform: translate(0, -50%) !important;
  left: 8px !important;
}

.VueCarousel-navigation-prev:hover {
  transform: translate(-4px, -50%) !important;
}

.VueCarousel-navigation-next {
  transform: translate(0, -50%) rotate(180deg) !important;
  right: 8px !important;
}

.VueCarousel-navigation-next:hover {
  transform: translate(4px, -50%) rotate(180deg) !important;
}

.donation__cta {}
</style>
